module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tocheading"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc_front"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Maps"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("List of maps")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_front"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Illustrations"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("List of illustrations")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_front1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 1:")]), _vm._v(" Decline of the West?")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 2:")]), _vm._v(" Law of the Jungle")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 3:")]), _vm._v(" ‘Always Look on the Bright Side of Life’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 4:")]), _vm._v(" Where did the Islamic State come from?")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 5:")]), _vm._v(" Taking on the Islamists")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 6:")]), _vm._v(" Dealing with Russia")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 7:")]), _vm._v(" Wider threats to the West")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Chapter 8:")]), _vm._v(" Future Options")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_back1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Conclusion")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_back"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Endnotes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_back"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Select Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0